import Vue from 'vue'
import type {ShopState} from './state'
import type {Commit, Dispatch} from 'vuex'
import {SET_FILTER_ENTITIES, SET_SHOP} from './mutation-types'
import type {Shop} from './types'
import {RESET} from '../configuration/mutation-types'

type ShopActionContext = { commit: Commit, dispatch: Dispatch, state: ShopState }

const fetchBasicFilters = async ({commit, state}: ShopActionContext) => {
  const criteria = {
    salesChannels: state.shopConfig.salesChannelIds || []
  }
  try {
    const filterEntities = await Vue.prototype.$container.productsApiClient.getFilters(criteria)

    commit(SET_FILTER_ENTITIES, filterEntities)
  } catch (e) {
  }
}

const switchShop = ({commit, dispatch}: ShopActionContext, shop: Shop) => {
  commit(SET_SHOP, shop)
  commit('configuration/' + RESET, null, {root: true})
}

export default {
  fetchBasicFilters,
  switchShop
}



// WEBPACK FOOTER //
// ./src/store/modules/shop/actions.js